import type { ConstValues } from '@openx/types/helpers';

export const ActionType = {
  EMPTY: 'EMPTY',
  QUESTION: 'QUESTION',
  REDIRECT: 'REDIRECT',
  FUNCTION: 'FUNCTION',
} as const;
export type ActionType = ConstValues<typeof ActionType>;
